import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var WebsiteIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsxs("g", {
                            clipPath: "url(#website__a)",
                            children: [
                                _jsx("path", {
                                    d: "M19 3H5C3.35 3 2 4.35 2 6v12c0 1.65 1.35 3 3 3h14c1.65 0 3-1.35 3-3V6c0-1.65-1.35-3-3-3zm1 15c0 .55-.45 1-1 1H5c-.55 0-1-.45-1-1v-7h16v7zm0-9H4V6c0-.55.45-1 1-1h14c.55 0 1 .45 1 1v3z"
                                }),
                                _jsx("path", {
                                    d: "M18 8a1 1 0 100-2 1 1 0 000 2zm-3 0a1 1 0 100-2 1 1 0 000 2zm-3 0a1 1 0 100-2 1 1 0 000 2z"
                                })
                            ]
                        }),
                        _jsx("defs", {
                            children: _jsx("clipPath", {
                                id: "website__a",
                                children: _jsx("path", {
                                    transform: "translate(2 3)",
                                    d: "M0 0h20v18H0z"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
WebsiteIcon.isCarinaIcon = true;
export default WebsiteIcon;
